// extracted by mini-css-extract-plugin
export default {"closeButton":"_2mVSEFFZiHOV_eS7TfeFnd","title":"_7BvdJ3bwNzQYC_AGq6mld","userEmail":"zOwJSOpYbGbd7MZydFs9X","emailType":"_2IVwl02GDEeQuiZzl88C9J"};